import { memo } from 'react';

import { Skeleton } from '@air/component-skeleton';

export const DiscussionSkeleton = memo(() => {
  return (
    <div className="pt-4">
      <div className="mr-7 mb-3 flex items-center lg:mr-11">
        <Skeleton height={24} style={{ marginRight: 12 }} variant="round" width={24} />
        <Skeleton height={10} width={60} />
      </div>
      <div className="mr-7 pt-2 pb-5 lg:mr-11">
        <Skeleton height={10} style={{ marginBottom: 8, marginLeft: 36 }} width="calc(90% - 36px)" />
        <Skeleton height={10} style={{ marginBottom: 8, marginLeft: 36 }} width="calc(100% - 36px)" />
        <Skeleton height={10} style={{ marginLeft: 36 }} width="calc(70% - 36px)" />
      </div>
    </div>
  );
});

DiscussionSkeleton.displayName = 'DiscussionSkeleton';
